var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderItem1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.15 2.96752L154.857 1.67429L153.564 0.380859L104.253 1.6785L52.2866 1.67849L2.98675 0.381127L1.68835 1.67954L0.389926 2.97795L1.6873 52.2778L1.68729 104.245L0.389648 153.555L1.6829 154.848L2.97615 156.142L52.2866 154.844H104.253L153.538 156.141L154.844 154.835L156.15 153.529L154.853 104.245V52.2778L156.15 2.96752ZM25.0771 23.2409L24.1635 24.1546L23.2497 25.0683L24.1665 59.9046V96.6177L23.2499 131.447L24.1672 132.364L25.0845 133.281L59.9134 132.365H96.6265L131.463 133.281L132.377 132.368L133.29 131.454L132.374 96.6177V59.9046L133.29 25.0863L132.367 24.1638L131.445 23.2413L96.6265 24.1576H59.9134L25.0771 23.2409Z",
    fill: "url(#paint0_radial_57_1389)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_57_1389",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.389692 163.708) rotate(-61.1691) scale(254.152 292.779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5219F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderItem1);
export default __webpack_public_path__ + "static/media/header-item-1.246264cc1c4ea3d2d47fa3e885d64b26.svg";
export { ForwardRef as ReactComponent };